import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

// D89: „Pełnej karty” już nie ma — jedyny widok apteki to panel na liście. Stary adres
// (linki w innych modułach, zakładki, wiadomości) przekierowuje na listę z otwartym
// panelem. Link do dnia w tabeli (`table` + `day`) zawęża zestawienie do miesiąca.
const isoDate = z
	.string()
	.regex(/^\d{4}-\d{2}-\d{2}$/)
	.optional()
	.catch(undefined);

const searchSchema = z.object({
	scope: z.string().optional().catch(undefined),
	table: z
		.string()
		.regex(/^[a-z0-9_]{1,32}$/)
		.optional()
		.catch(undefined),
	day: isoDate,
});

export type SynchronizacjaAptekaSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/synchronizacja/apteki/$idfirm")({
	// Ten sam grant co lista i wpis w sidebarze — przekierowanie nie omija strażnika.
	beforeLoad: async ({ context, location, params, search }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.synchronizacja-apteki",
			location.pathname,
		);
		const idfirm = Number(params.idfirm);
		const apteka = Number.isInteger(idfirm) && idfirm > 0 ? idfirm : undefined;
		throw redirect({
			to: "/synchronizacja/apteki",
			search: {
				apteka,
				scope: search.scope,
				miesiac:
					apteka && search.table && search.day
						? `${search.table}:${search.day.slice(0, 7)}`
						: undefined,
			},
			replace: true,
		});
	},
	validateSearch: (search: Record<string, unknown>): SynchronizacjaAptekaSearch =>
		searchSchema.parse(search),
});
